import { Box, Grid, Toolbar, Typography } from "@mui/material";
import {
  COUNTRY_CODES,
  INITIAL_SNACKBAR_DATA,
  SessionOptions,
  durationOptions,
} from "../../common/constants";
import {
  EnhancedDialog,
  EnhancedDropDownRHFWithLabel,
  EnhancedSnackbar,
  IEnhancedDropDownItem,
  LabelPosition,
  RHookFormPasswordFieldWithLabel,
  RHookFormTextFieldWithLabel,
  SingleColumnLayout,
  Spacer,
  StandardPanel,
  TwoColumnLayout,
} from "@websential/cosmic-v20";
import { FormProvider, useForm } from "react-hook-form";
import {
  addPhoneNumberFormSchema,
  changePasswordFormSchema,
  otpAuthFormSchema,
} from "./validator";
import { useEffect, useState } from "react";

import { AuthService } from "../../services";
import { EnhancedButtonPrimeReact } from "../../../src/components/EnhancedButtonPrimeReact/index";
import { EnhancedButtonPrimeReactSeverity } from "../../common/Common";
import ItsReallyYouImportModal from "./ItsReallyYouForm";
import { useMutation } from "@tanstack/react-query";
import { yupResolver } from "@hookform/resolvers/yup";

type ChangePasswordFormValues = {
  otp: string;
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
};

type UpdateActiveSessionFormValues = {
  autoLogoutAfter: string;
  defaultMethod: string;
};

type OtpCodeDataFormValues = {
  otp: string;
};

export const UserAccountSettingForm = () => {
  const formMethods = useForm<ChangePasswordFormValues>({
    mode: "onBlur",
    reValidateMode: "onChange",
    resolver: yupResolver(changePasswordFormSchema),
  });

  const formMethods1 = useForm<UpdateActiveSessionFormValues>({
    mode: "onBlur",
    reValidateMode: "onChange",
  });

  const formMethods2 = useForm<OtpCodeDataFormValues>({
    mode: "onBlur",
    reValidateMode: "onChange",
    resolver: yupResolver(otpAuthFormSchema),
  });

  const formMethods3 = useForm<OtpCodeDataFormValues>({
    mode: "onBlur",
    reValidateMode: "onChange",
    resolver: yupResolver(otpAuthFormSchema),
  });
  const formMethods4 = useForm<OtpCodeDataFormValues>({
    mode: "onBlur",
    reValidateMode: "onChange",
    resolver: yupResolver(otpAuthFormSchema),
  });

  const formMethods6 = useForm<any>({
    mode: "onBlur",
    reValidateMode: "onChange",
    resolver: yupResolver(addPhoneNumberFormSchema),
  });

  const formMethods7 = useForm<OtpCodeDataFormValues>({
    mode: "onBlur",
    reValidateMode: "onChange",
    resolver: yupResolver(otpAuthFormSchema),
  });

  const [defaultMethodsCheck, setDefaultMethodsCheck] = useState<
    string | null | any
  >(null);
  const [phoneLinkButtonsCondition, setPhoneLinkButtonsCondition] = useState<
    string | null | any
  >(null);
  const [googleLinkButtonsCondition, setGoogleLinkButtonsCondition] = useState<
    string | null | any
  >(null);
  const [phoneNotLinkButtonsCondition, setPhoneNotLinkButtonsCondition] =
    useState<string | null | any>(null);
  const [googleNotLinkButtonsCondition, setGoogleNotLinkButtonsCondition] =
    useState<string | null | any>(null);
  const [phoneNotExistButtonsCondition, setPhoneNotExistButtonsCondition] =
    useState<string | null | any>(null);
  const [openModal, setOpenModal] = useState(false);
  const [openAddPhoneModal, setOpenAddPhoneModal] = useState(false);
  const [qrCodeBase64, setqrCodeBase64] = useState<string | null | any>(null);
  const [openPhoneModal, setOpenPhoneModal] = useState(false);
  const [itsReallyYouGoogleModel, setOpenItsReallyYouGoogleModel] =
    useState(false);
  const [
    itsReallyYouDisconnectGoogleModel,
    setOpenItsReallyYouDisconnectGoogleModel,
  ] = useState(false);
  const [itsReallyYouPhoneModel, setOpenItsReallyYouPhoneModel] =
    useState(false);
  const [itsReallyYouLinkPhoneModel, setOpenItsReallyYouLinkPhoneModel] =
    useState(false);
  const [
    itsReallyYouDisconnectPhoneModel,
    setOpenItsReallyYouDisconnectPhoneModel,
  ] = useState(false);
  const [CountryCodeValue, setCountryCodeValue] = useState<any>("+1");
  const [PhoneNumberPlaceholder, setPhoneNumberPlaceholder] =
    useState<any>("(123) 456-7890");
  const [PhoneNumberInputMaskPattern, setPhoneNumberInputMaskPattern] =
    useState<any>("(000) 000-0000");
  const [showOtpField, setShowOtpField] = useState(false);
  const [expireAfterSelectedValue, setExpireAfterSelectedValue] =
    useState<any>(undefined);
  const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
  const accessToken = localStorage.getItem("accessToken") || "";

  const onSnackbarClosed = (
    _event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarData(INITIAL_SNACKBAR_DATA);
  };

  const downloadBackupCodesCSV = (backupCodes: any[]) => {
    const headers = ["Code", "Used", "Created At"];
    const rows = backupCodes.map((code) => [
      code.code,
      code.used ? "Yes" : "No",
      new Date(code.createdAt).toLocaleString(),
    ]);

    const csvContent = [headers, ...rows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "backup_codes.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const { mutate: mutateChangePassword, isPending: changePasswordisPending } =
    useMutation({
      mutationFn: AuthService.changePassword,
      onSuccess: (res: any) => {
        if (res.status) {
          setSnackbarData({
            open: true,
            message: res.message,
            severity: "success",
          });
        } else {
          setSnackbarData({
            open: true,
            message: res.message,
            severity: "error",
          });
        }
      },
    });

  const {
    mutate: mutateUpdateActiveSession,
    isPending: updateSessionMutation,
  } = useMutation({
    mutationFn: AuthService.UpdateActiveSessionTime,
    onSuccess: (res: any) => {
      if (res.status) {
        setSnackbarData({
          open: true,
          message: res.message,
          severity: "success",
        });
      } else if (res.ststus === false) {
        setSnackbarData({
          open: true,
          message: res.message,
          severity: "error",
        });
      }
    },
  });

  const {
    mutate: mutateGenerateBackupCodeData,
    isPending: GenerateBackupCodeDataReloading,
  } = useMutation({
    mutationFn: AuthService.generateBackupCodeData,

    onSuccess: (res: any) => {
      if (res.backupCodes && Array.isArray(res.backupCodes)) {
        downloadBackupCodesCSV(res.backupCodes);
        setSnackbarData({
          open: true,
          message: "Success",
          severity: "success",
        });
      } else {
        setSnackbarData({
          open: true,
          message: res.message,
          severity: "error",
        });
      }
    },
  });

  const onClickSendOtp = () => {
    AuthService.CreateOtpByMessege(accessToken)
      .then((res: any) => {
        if (res.status) {
          setSnackbarData({
            open: true,
            message: res.message,
            severity: "success",
          });
        } else if (res.ststus === false) {
          setSnackbarData({
            open: true,
            message: res.message,
            severity: "error",
          });
        }
      })
      .catch((error) => {
        console.error("Error sending OTP:", error);
      });
  };

  const onClickDisconnectGoogle = () => {
    AuthService.disconnectGoogleOrPhone("google")
      .then((res: any) => {
        if (res.status) {
          setSnackbarData({
            open: true,
            message: res.message,
            severity: "success",
          });
        } else if (res.ststus === false) {
          setSnackbarData({
            open: true,
            message: res.message,
            severity: "error",
          });
        }
      })
      .catch((error) => {
        console.error("Error sending OTP:", error);
      });
  };

  const onClickDisconnectPhone = () => {
    AuthService.disconnectGoogleOrPhone("phone")
      .then((res: any) => {
        if (res.status) {
          setSnackbarData({
            open: true,
            message: res.message,
            severity: "success",
          });
        } else if (res.ststus === false) {
          setSnackbarData({
            open: true,
            message: res.message,
            severity: "error",
          });
        }
      })
      .catch((error) => {
        console.error("Error sending OTP:", error);
      });
  };

  const generateConnectWithGoogleAuth = useMutation({
    mutationFn: () => AuthService.ConnectWithGoogleAuth(accessToken),

    onSuccess: (res: any) => {
      setqrCodeBase64(res.qrCode);
    },
    onError: () => { },
  });

  const handleCodeRequest = (type: "sms" | "call") => {
    if (!accessToken) {
      setSnackbarData({
        open: true,
        message: "Missing access token. Please login again.",
        severity: "error",
      });
      return;
    }
    const api =
      type === "sms"
        ? () => AuthService.CreateOtpByMessege(accessToken)
        : () => AuthService.verifyOtpByMessege(accessToken);

    api()
      .then((res: any) => {
        if (res.status && res.accessToken) {
          // localStorage.setItem("accessToken", res.accessToken);
        }

        setSnackbarData({
          open: true,
          message: res.message,
          severity: res.status ? "success" : "error",
        });
      })
      .catch(() => {
        setSnackbarData({
          open: true,
          message: "Failed to send code. Try again later!",
          severity: "error",
        });
      });
  };

  const verifyOtpMutation = useMutation({
    mutationFn: AuthService.VerifyOtpByMessegeForPhoneNumberSave,
    onSuccess: (res: any) => {
      if (res.status) {
        setSnackbarData({
          open: true,
          message:
            res.message || "Phone number verified and added successfully.",
          severity: "success",
        });
      } else {
        setSnackbarData({
          open: true,
          message: res.message,
          severity: "error",
        });
      }
    },
    onError: () => {
      setSnackbarData({
        open: true,
        message: "OTP verification failed. Try again!",
        severity: "error",
      });
    },
  });

  const sendOtpMutation = useMutation({
    mutationFn: AuthService.CreateOtpByMessegeForPhoneNumberSave,
    onSuccess: (res: any) => {
      if (res.status) {
        // localStorage.setItem("accessToken", res.accessToken);
        setShowOtpField(true);
        setSnackbarData({
          open: true,
          message: res.message,
          severity: res.status ? "success" : "error",
        });
      } else {
        setSnackbarData({
          open: true,
          message: res.message,
          severity: res.status ? "success" : "error",
        });
      }
    },
    onError: () => {
      setSnackbarData({
        open: true,
        message: "Something went wrong, try again later!",
        severity: "error",
      });
      setShowOtpField(false);
    },
  });

  const onSubmitToAddPhone = (formValues: any) => {
    const fullPhone = `${formValues.countryCode}${formValues.phone}`;
    if (showOtpField) {
      const payload = {
        accessToken: accessToken,
        phone: fullPhone,
        otp: formValues.otp,
      };
      verifyOtpMutation.mutate(payload);
    } else {
      const payload = {
        accessToken: accessToken,
        phone: fullPhone,
      };
      sendOtpMutation.mutate(payload);
    }
  };

  const { isPending, mutate } = useMutation({
    mutationFn: AuthService.verifyQrCode,
    onSuccess: async (res: any) => {
      if (res.status && res.user?.twoFactorAuth) {
        // localStorage.setItem("accessToken", res.user.accessToken);
        setSnackbarData({
          open: true,
          message: "you are successfully Linked with Google Authenticator",
          severity: res.status ? "success" : "error",
        });
        setOpenModal(false);
      } else {
        setSnackbarData({
          open: true,
          message: res.message,
          severity: res.status ? "success" : "error",
        });
      }
    },
  });

  const { mutate: mutateVerifyOtpData, isPending: VerifyOtpDataForLinkDevice } =
    useMutation({
      mutationFn: AuthService.verifyOtpByMessege,
      onSuccess: async (res: any) => {
        if (res.status && res.user?.twoFactorAuth) {
          setSnackbarData({
            open: true,
            message: "you are successfully Linked with Phone",
            severity: res.status ? "success" : "error",
          });
        } else {
          setSnackbarData({
            open: true,
            message: res.message,
            severity: res.status ? "success" : "error",
          });
        }
      },
    });

  let mutationFnCall;
  if (defaultMethodsCheck === "phone") {
    mutationFnCall = AuthService.verifyOtpByMessege;
  } else if (defaultMethodsCheck === "google") {
    mutationFnCall = AuthService.verifyQrCode;
  } else {
    mutationFnCall = () => Promise.reject("Invalid method");
  }

  const {
    mutate: mutateVerifyOtpForItsRealyYou,
    isPending: VerifyOtpDataForItsRealyYou,
  } = useMutation({
    mutationFn: mutationFnCall,
    onSuccess: async (res: any, variables: any) => {
      const context = variables.context;
      if (res.status && res.user?.twoFactorAuth) {
        setSnackbarData({
          open: true,
          message: "you are successfully Verified.",
          severity: res.status ? "success" : "error",
        });
        if (variables.context === "phoneScreen") {
          setOpenItsReallyYouPhoneModel(false);
          setOpenAddPhoneModal(true);
        } else if (variables.context === "googleScreen") {
          setOpenItsReallyYouGoogleModel(false);
          generateConnectWithGoogleAuth.mutate();
          setOpenModal(true);
        } else if (variables.context === "phoneLinkScreen") {
          setOpenItsReallyYouLinkPhoneModel(false);
          setOpenPhoneModal(true);
        } else if (variables.context === "disconnectGoogle") {
          setOpenItsReallyYouDisconnectGoogleModel(false);
          onClickDisconnectGoogle();
        } else if (variables.context === "disconnectPhone") {
          setOpenItsReallyYouDisconnectPhoneModel(false);
          onClickDisconnectPhone();
        }
      } else {
        setSnackbarData({
          open: true,
          message: res.message,
          severity: res.status ? "success" : "error",
        });
      }
    },
  });

  useEffect(() => {
    const check2fmethoddetail = async () => {
      try {
        const response: any = await AuthService.GetAvailable2FAMethods(
          accessToken
        );
        if (response.status) {
          const PhoneLinkCheckup: any =
            response.twoFactorAuth &&
            (response.defaultMethod === "phone" ||
              response.twoFactorTypes.includes("phone"));
          const GoogleLinkCheckup: any =
            response.twoFactorAuth &&
            (response.defaultMethod === "google" ||
              response.twoFactorTypes.includes("google"));
          if (
            response.defaultLoginMethod &&
            response.defaultLoginMethod.trim() !== ""
          ) {
            setDefaultMethodsCheck(response.defaultLoginMethod);
          } else if (response.twoFactorTypes.length === 1) {
            setDefaultMethodsCheck(response.twoFactorTypes[0]);
          }
          const PhoneNotLinkCheckup: any =
            response.twoFactorAuth &&
            response.phone !== null &&
            !response.twoFactorTypes.includes("phone");
          const GoogleNotLinkCheckup: any =
            response.twoFactorAuth &&
            !response.twoFactorTypes.includes("google");
          const PhoneNumberNotGivenCheckup: any =
            response.twoFactorAuth && response.phone === null;
          // if (response.twoFactorTypes.length === 2)
          setPhoneLinkButtonsCondition(PhoneLinkCheckup);
          setGoogleLinkButtonsCondition(GoogleLinkCheckup);
          setPhoneNotLinkButtonsCondition(PhoneNotLinkCheckup);
          setGoogleNotLinkButtonsCondition(GoogleNotLinkCheckup);
          setPhoneNotExistButtonsCondition(PhoneNumberNotGivenCheckup);
          if (response.twoFactorTypes.includes("phone")) {
            if (!SessionOptions.some((option) => option.value === "phone")) {
              SessionOptions.push({ label: "Phone", value: "phone" });
            }
          }

          if (response.twoFactorTypes.includes("google")) {
            if (!SessionOptions.some((option) => option.value === "google")) {
              SessionOptions.push({
                label: "Google Authenticator",
                value: "google",
              });
            }
          }
        }
      } catch (error) {
        console.error("Failed to fetch phone status:", error);
      } finally {
      }
    };

    check2fmethoddetail();
  }, []);

  const onExpireAfterChangeHandler = (params: IEnhancedDropDownItem) => {
    setExpireAfterSelectedValue(params.value);
  };

  const onSubmitGenerateBackupCodes = (formValues: OtpCodeDataFormValues) => {
    mutateGenerateBackupCodeData(formValues);
  };

  const onSubmitUpdateActiveSession = (
    formValues: UpdateActiveSessionFormValues
  ) => {
    mutateUpdateActiveSession(formValues);
  };

  const onSubmitChangePassword = (formValues: ChangePasswordFormValues) => {
    mutateChangePassword(formValues);
  };

  const onSubmitGoogleVerifies = (formValues: any) => {
    formValues.accessToken = accessToken;
    mutate(formValues);
  };

  const onSubmitPhoneVerifies = (formValues: any) => {
    formValues.accessToken = accessToken;
    mutateVerifyOtpData(formValues);
  };

  const onSubmitPhoneGoogleVerifiesForItsRealyYou = (formValues: any) => {
    formValues.context = "phoneScreen";
    formValues.accessToken = accessToken;
    mutateVerifyOtpForItsRealyYou(formValues);
  };

  const onSubmitPhoneGoogleVerifiesForItsRealyYouGooogle = (
    formValues: any
  ) => {
    formValues.accessToken = accessToken;
    formValues.context = "googleScreen";
    mutateVerifyOtpForItsRealyYou(formValues);
  };

  const onSubmitDisconnectPhoneForItsRealyYou = (formValues: any) => {
    formValues.accessToken = accessToken;
    formValues.context = "disconnectPhone";
    mutateVerifyOtpForItsRealyYou(formValues);
  };

  const onSubmitDisconnectGoogleForItsRealyYou = (formValues: any) => {
    formValues.accessToken = accessToken;
    formValues.context = "disconnectGoogle";
    mutateVerifyOtpForItsRealyYou(formValues);
  };

  const onSubmitLinkPhoneForItsRealyYou = (formValues: any) => {
    formValues.accessToken = accessToken;
    formValues.context = "phoneLinkScreen";
    mutateVerifyOtpForItsRealyYou(formValues);
  };

  const onCountryCodeSelectionChangeHandler = (selectedCountry: any) => {
    const foundCountry = COUNTRY_CODES.find(
      (c) => c.value === selectedCountry.value
    );
    if (foundCountry) {
      formMethods6.setValue("phone", "");
      setCountryCodeValue(foundCountry.value);
      setPhoneNumberInputMaskPattern(foundCountry.mask);
      setPhoneNumberPlaceholder(foundCountry.placeholder);
    }
  };

  const handleAuthorizePhoneClick = () => {
    setOpenItsReallyYouLinkPhoneModel(true);
  };

  const checkHandleMethodsForItsReallyYou = () => {
    setOpenItsReallyYouGoogleModel(true);
  };

  const checkHandleMethodsForItsReallyYouForPhone = () => {
    setOpenItsReallyYouPhoneModel(true);
  };

  const onClickDisconnectPhoneForItsReallyYouFor = () => {
    setOpenItsReallyYouDisconnectPhoneModel(true);
  };

  const onClickDisconnectGoogleForItsReallyYouFor = () => {
    setOpenItsReallyYouDisconnectGoogleModel(true);
  };

  return (
    <>
      <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
          <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            {/* <Grid
              size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
              sx={{
                border: "1px solid rgba(0, 0, 0, 0.12)",
                borderRadius: "3px",
                marginTop: "16px",
              }} */}
            <Grid
              size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}
              sx={{
                border: "1px solid rgba(0, 0, 0, 0.12)",
                borderRadius: "3px",
                marginTop: "16px",
              }}
            >
              <TwoColumnLayout
                leftColumnContent={
                  <>
                    <FormProvider {...formMethods}>
                      <form
                        onSubmit={formMethods.handleSubmit(
                          onSubmitChangePassword
                        )}
                      >
                        <SingleColumnLayout
                          children={
                            <StandardPanel
                              title="Change Password"
                              testId={`Change Password`}
                              // leftSpacing={1}
                              // rightSpacing={1}
                              variant="outlined"
                              borderHide={true}
                              borderBottom={true}
                            >
                              <>
                                {defaultMethodsCheck === "google" ? (
                                  <RHookFormTextFieldWithLabel
                                    label="Enter code from linked google authenticator"
                                    id="otp"
                                    testId="otp"
                                    placeholder="Enter OTP 123564"
                                  />
                                ) : (
                                  <RHookFormTextFieldWithLabel
                                    label="Enter code sent to your phone"
                                    id="otp"
                                    testId="otp"
                                    placeholder="Enter OTP 123564"
                                    labelPosition={LabelPosition.Top}
                                  />
                                )}

                                <RHookFormPasswordFieldWithLabel
                                  label="Old Password"
                                  id="oldPassword"
                                  testId="oldPassword"
                                  placeholder="Minimum 8 Characters"
                                />

                                <RHookFormPasswordFieldWithLabel
                                  label="New Password"
                                  id="newPassword"
                                  testId="newPassword"
                                  placeholder="Minimum 8 Characters"
                                />

                                <RHookFormPasswordFieldWithLabel
                                  label="Confirm Password"
                                  id="confirmNewPassword"
                                  testId="confirmNewPassword"
                                  placeholder="Minimum 8 Characters"
                                />
                              </>
                            </StandardPanel>
                          }
                          toolbar={
                            <>
                              {defaultMethodsCheck === "phone" ? (
                                <Toolbar>
                                  <>
                                    <EnhancedButtonPrimeReact
                                      label="Update"
                                      loading={changePasswordisPending}
                                      type="submit"
                                      raised
                                      // style={{ marginLeft: "3.8rem" }}
                                      severity={
                                        EnhancedButtonPrimeReactSeverity.Success
                                      }
                                    />
                                    <EnhancedButtonPrimeReact
                                      label="Send OTP"
                                      // type="submit"
                                      raised
                                      style={{ marginLeft: "1rem" }}
                                      onClickHandler={onClickSendOtp}
                                      severity={
                                        EnhancedButtonPrimeReactSeverity.Secondary
                                      }
                                    />
                                  </>
                                </Toolbar>
                              ) : (
                                <Toolbar>
                                  <EnhancedButtonPrimeReact
                                    label="Update"
                                    loading={changePasswordisPending}
                                    type="submit"
                                    raised
                                    style={{ marginLeft: "7.8rem" }}
                                    severity={
                                      EnhancedButtonPrimeReactSeverity.Success
                                    }
                                  />
                                </Toolbar>
                              )}
                            </>
                          }
                          showFullDiaplay={true}
                          toolbarPosition="bottom"
                          testId="form-layout"
                        />
                      </form>
                    </FormProvider>

                    <FormProvider {...formMethods1}>
                      <form
                        onSubmit={formMethods1.handleSubmit(
                          onSubmitUpdateActiveSession
                        )}
                      >
                        <SingleColumnLayout
                          children={
                            <StandardPanel
                              title="Active Session Time"
                              testId={`Active Session Time`}
                              // leftSpacing={1}
                              // rightSpacing={1}
                              variant="outlined"
                              borderHide={true}
                              borderBottom={true}
                            >
                              <>
                                <EnhancedDropDownRHFWithLabel
                                  label="Auto Log out after"
                                  testId="autoLogoutAfter"
                                  selectName="autoLogoutAfter"
                                  items={durationOptions}
                                  onSelectionChangeHandler={
                                    onExpireAfterChangeHandler
                                  }
                                  selectedItem={expireAfterSelectedValue}
                                />
                                <EnhancedDropDownRHFWithLabel
                                  label="Chose Default Auth Method"
                                  testId="defaultMethod"
                                  selectName="defaultMethod"
                                  items={SessionOptions}
                                  onSelectionChangeHandler={
                                    onExpireAfterChangeHandler
                                  }
                                  selectedItem={expireAfterSelectedValue}
                                />
                              </>
                            </StandardPanel>
                          }
                          toolbar={
                            <Toolbar>
                              <EnhancedButtonPrimeReact
                                label="Save"
                                loading={updateSessionMutation}
                                type="submit"
                                raised
                                severity={
                                  EnhancedButtonPrimeReactSeverity.Success
                                }
                              />
                            </Toolbar>
                          }
                          showFullDiaplay={true}
                          toolbarPosition="bottom"
                          testId="form-layout"
                        />
                      </form>
                    </FormProvider>
                  </>
                }
                rightColumnContent={
                  <>
                    <SingleColumnLayout
                      children={
                        <StandardPanel
                          title="Connect With Google Authenticator"
                          testId={`Connect With Google Authenticator`}
                          // leftSpacing={1}
                          // rightSpacing={1}
                          variant="outlined"
                          borderHide={true}
                          borderBottom={true}
                        >
                          <p
                            style={{
                              // fontWeight: "bold",
                              fontSize: "0.85rem",
                              color: "#666",
                              margin: "8px 0",
                            }}
                          >
                            If you're not already set up with Google
                            Authenticator, we recommend doing so. This way, if
                            phone based authentication (SMS or call) fails, you
                            can still sign in using Google Authenticator.
                          </p>
                        </StandardPanel>
                      }
                      toolbar={
                        <>
                          {googleLinkButtonsCondition ? (
                            <Toolbar>
                              <>
                                <EnhancedButtonPrimeReact
                                  label="Reconnect"
                                  raised
                                  // style={{ marginLeft: "3.8rem" }}
                                  onClickHandler={() =>
                                    checkHandleMethodsForItsReallyYou()
                                  }
                                  severity={
                                    EnhancedButtonPrimeReactSeverity.Success
                                  }
                                />
                                <EnhancedButtonPrimeReact
                                  label="Disconnect"
                                  raised
                                  style={{ marginLeft: "1rem" }}
                                  onClickHandler={
                                    onClickDisconnectGoogleForItsReallyYouFor
                                  }
                                  severity={
                                    EnhancedButtonPrimeReactSeverity.Danger
                                  }
                                />
                              </>
                            </Toolbar>
                          ) : googleNotLinkButtonsCondition ? (
                            <Toolbar>
                              <>
                                <EnhancedButtonPrimeReact
                                  label="Connect"
                                  raised
                                  // style={{ marginLeft: "7.8rem" }}
                                  // onClickHandler={() => handleReconnectWithGoogle()}
                                  onClickHandler={() =>
                                    checkHandleMethodsForItsReallyYou()
                                  }
                                  severity={
                                    EnhancedButtonPrimeReactSeverity.Success
                                  }
                                />
                              </>
                            </Toolbar>
                          ) : null}
                        </>
                      }
                      showFullDiaplay={true}
                      toolbarPosition="bottom"
                      testId="form-layout"
                    />

                    <SingleColumnLayout
                      children={
                        <StandardPanel
                          title="Connect With Phone"
                          testId={`Connect With Phone`}
                          // leftSpacing={1}
                          // rightSpacing={1}
                          variant="outlined"
                          borderHide={true}
                          borderBottom={true}
                        >
                          <p
                            style={{
                              // fontWeight: "bold",
                              fontSize: "0.85rem",
                              color: "#666",
                              margin: "8px 0",
                            }}
                          >
                            If you're not set up with Phone Authenticator yet,
                            we recommend doing so as a backup in case Google
                            authentication doesn't work.
                          </p>
                        </StandardPanel>
                      }
                      toolbar={
                        <>
                          {phoneLinkButtonsCondition ? (
                            <Toolbar>
                              <>
                                <EnhancedButtonPrimeReact
                                  label="Update"
                                  type="submit"
                                  raised
                                  // style={{ marginLeft: "3.8rem" }}
                                  onClickHandler={() =>
                                    checkHandleMethodsForItsReallyYouForPhone()
                                  }
                                  severity={
                                    EnhancedButtonPrimeReactSeverity.Success
                                  }
                                />
                                <EnhancedButtonPrimeReact
                                  label="Disconnect"
                                  // type="submit"
                                  raised
                                  style={{ marginLeft: "1rem" }}
                                  onClickHandler={
                                    onClickDisconnectPhoneForItsReallyYouFor
                                  }
                                  severity={
                                    EnhancedButtonPrimeReactSeverity.Danger
                                  }
                                />
                              </>
                            </Toolbar>
                          ) : phoneNotLinkButtonsCondition ? (
                            <Toolbar>
                              <>
                                <EnhancedButtonPrimeReact
                                  label="Update"
                                  type="submit"
                                  raised
                                  // style={{ marginLeft: "3.8rem" }}
                                  onClickHandler={() =>
                                    checkHandleMethodsForItsReallyYouForPhone()
                                  }
                                  severity={
                                    EnhancedButtonPrimeReactSeverity.Success
                                  }
                                />
                                <EnhancedButtonPrimeReact
                                  label="Connect"
                                  raised
                                  // style={{ marginLeft: "3.8rem" }}
                                  onClickHandler={() =>
                                    handleAuthorizePhoneClick()
                                  }
                                  severity={
                                    EnhancedButtonPrimeReactSeverity.Success
                                  }
                                />
                              </>
                            </Toolbar>
                          ) : phoneNotExistButtonsCondition ? (
                            <Toolbar>
                              <>
                                <EnhancedButtonPrimeReact
                                  label="Add Phone"
                                  onClickHandler={() =>
                                    checkHandleMethodsForItsReallyYouForPhone()
                                  }
                                  type="submit"
                                  raised
                                  // style={{ marginLeft: "7.8rem" }}
                                  severity={
                                    EnhancedButtonPrimeReactSeverity.Success
                                  }
                                />
                              </>
                            </Toolbar>
                          ) : null}
                        </>
                      }
                      showFullDiaplay={true}
                      toolbarPosition="bottom"
                      testId="form-layout"
                    />

                    <SingleColumnLayout
                      children={
                        <StandardPanel
                          title="BackUp Codes"
                          testId={`BackUp Codes`}
                          // leftSpacing={1}
                          // rightSpacing={1}
                          variant="outlined"
                          borderHide={true}
                          borderBottom={true}
                        >
                          <>
                            <p
                              style={{
                                // fontWeight: "bold",
                                fontSize: "0.85rem",
                                color: "#666",
                                margin: "8px 0",
                              }}
                            >
                              If your phone is unavailable, these codes will be
                              the only way to sign in to your account. Keep the
                              codes secure and accessible.
                            </p>
                            <Spacer y={2} x={2} />
                            {/* <Grid> */}
                            <FormProvider {...formMethods2}>
                              <form
                                onSubmit={formMethods2.handleSubmit(
                                  onSubmitGenerateBackupCodes
                                )}
                              >
                                {defaultMethodsCheck === "phone" ? (
                                  <RHookFormTextFieldWithLabel
                                    label="Enter code sent to your phone"
                                    id="otp"
                                    testId="otp"
                                    placeholder="Enter OTP 123564"
                                  />
                                ) : (
                                  <RHookFormTextFieldWithLabel
                                    label="Enter code from linked google authenticator"
                                    id="otp"
                                    testId="otp"
                                    placeholder="Enter OTP 123564"
                                  />
                                )}
                              </form>
                            </FormProvider>
                          </>
                        </StandardPanel>
                      }
                      toolbar={
                        <>
                          {defaultMethodsCheck === "phone" ? (
                            <Toolbar>
                              <>
                                <EnhancedButtonPrimeReact
                                  label="Generate"
                                  loading={GenerateBackupCodeDataReloading}
                                  type="submit"
                                  raised
                                  // style={{ marginLeft: "3.8rem" }}
                                  onClickHandler={formMethods2.handleSubmit(
                                    onSubmitGenerateBackupCodes
                                  )}
                                  severity={
                                    EnhancedButtonPrimeReactSeverity.Success
                                  }
                                />
                                <EnhancedButtonPrimeReact
                                  label="Send OTP"
                                  // type="submit"
                                  raised
                                  style={{ marginLeft: "1rem" }}
                                  onClickHandler={onClickSendOtp}
                                  severity={
                                    EnhancedButtonPrimeReactSeverity.Secondary
                                  }
                                />
                              </>
                            </Toolbar>
                          ) : (
                            <Toolbar>
                              <>
                                <EnhancedButtonPrimeReact
                                  label="Generate"
                                  loading={GenerateBackupCodeDataReloading}
                                  type="submit"
                                  raised
                                  // style={{ marginLeft: "8.8rem" }}
                                  onClickHandler={formMethods2.handleSubmit(
                                    onSubmitGenerateBackupCodes
                                  )}
                                  severity={
                                    EnhancedButtonPrimeReactSeverity.Success
                                  }
                                />
                              </>
                            </Toolbar>
                          )}
                        </>
                      }
                      showFullDiaplay={true}
                      toolbarPosition="bottom"
                      testId="form-layout"
                    />
                  </>
                }
                showToolbar={false}
                toolbarPosition="bottom"
                toolbar={<></>}
                testId={""}
              />
            </Grid>
          </Grid>

          <ItsReallyYouImportModal
            open={itsReallyYouPhoneModel}
            onClose={() => setOpenItsReallyYouPhoneModel(false)}
            formMethods={formMethods7}
            onSubmit={onSubmitPhoneGoogleVerifiesForItsRealyYou}
            defaultMethodsCheck={defaultMethodsCheck}
            loading={VerifyOtpDataForItsRealyYou}
            showSendOtpButton={defaultMethodsCheck === "phone"}
            onClickSendOtp={onClickSendOtp}
          />

          <ItsReallyYouImportModal
            open={itsReallyYouLinkPhoneModel}
            onClose={() => setOpenItsReallyYouLinkPhoneModel(false)}
            formMethods={formMethods7}
            onSubmit={onSubmitLinkPhoneForItsRealyYou}
            defaultMethodsCheck={defaultMethodsCheck}
            loading={VerifyOtpDataForItsRealyYou}
            showSendOtpButton={defaultMethodsCheck === "phone"}
            onClickSendOtp={onClickSendOtp}
          />

          <ItsReallyYouImportModal
            open={itsReallyYouGoogleModel}
            onClose={() => setOpenItsReallyYouGoogleModel(false)}
            formMethods={formMethods7}
            onSubmit={onSubmitPhoneGoogleVerifiesForItsRealyYouGooogle}
            defaultMethodsCheck={defaultMethodsCheck}
            loading={VerifyOtpDataForItsRealyYou}
            showSendOtpButton={defaultMethodsCheck === "phone"}
            onClickSendOtp={onClickSendOtp}
          />

          <ItsReallyYouImportModal
            open={itsReallyYouDisconnectGoogleModel}
            onClose={() => setOpenItsReallyYouDisconnectGoogleModel(false)}
            formMethods={formMethods7}
            onSubmit={onSubmitDisconnectGoogleForItsRealyYou}
            defaultMethodsCheck={defaultMethodsCheck}
            loading={VerifyOtpDataForItsRealyYou}
            showSendOtpButton={defaultMethodsCheck === "phone"}
            onClickSendOtp={onClickSendOtp}
          />

          <ItsReallyYouImportModal
            open={itsReallyYouDisconnectPhoneModel}
            onClose={() => setOpenItsReallyYouDisconnectPhoneModel(false)}
            formMethods={formMethods7}
            onSubmit={onSubmitDisconnectPhoneForItsRealyYou}
            defaultMethodsCheck={defaultMethodsCheck}
            loading={VerifyOtpDataForItsRealyYou}
            showSendOtpButton={defaultMethodsCheck === "phone"}
            onClickSendOtp={onClickSendOtp}
          />

          {/* Google Auth Modal */}
          <EnhancedDialog
            dialogTitle="Connect with Google Authenticator"
            key="dialog-box"
            testId="dialog"
            open={openModal}
            onCloseHandler={() => setOpenModal(false)}
            dialogContent={
              <FormProvider {...formMethods3}>
                <form
                  onSubmit={formMethods3.handleSubmit(
                    onSubmitGoogleVerifies,
                    (errors) => { }
                  )}
                >
                  {/* <h4>Connect with Google Authenticator</h4> */}
                  <Grid container spacing={2}>
                    {qrCodeBase64 && (
                      <Grid
                        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                        textAlign="center"
                      >
                        <img
                          src={qrCodeBase64}
                          alt="2FA QR Code"
                          style={{ maxWidth: 250 }}
                        />
                      </Grid>
                    )}

                    {/* <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}> */}
                    <RHookFormTextFieldWithLabel
                      label="Enter code from linked google authenticator"
                      id="otp"
                      testId="otp"
                      placeholder="Enter OTP"
                    />
                    {/* </Grid> */}
                  </Grid>

                  <EnhancedButtonPrimeReact
                    label="Link Device"
                    loading={isPending}
                    type="submit"
                    raised
                    severity={EnhancedButtonPrimeReactSeverity.Success}
                  />
                </form>
              </FormProvider>
            }
          />

          {/* phone Link Auth Modal */}
          <EnhancedDialog
            dialogTitle="Link With Cell No."
            key="dialog-box"
            testId="dialog"
            open={openPhoneModal}
            onCloseHandler={() => setOpenPhoneModal(false)}
            dialogContent={
              <FormProvider {...formMethods4}>
                <form
                  onSubmit={formMethods4.handleSubmit(
                    onSubmitPhoneVerifies,
                    (errors) => { }
                  )}
                >
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                      <RHookFormTextFieldWithLabel
                        label="Enter code sent on your phone"
                        id="otp"
                        testId="otp-field"
                        placeholder="Enter OTP code"
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                      <EnhancedButtonPrimeReact
                        label="Link Device"
                        loading={VerifyOtpDataForLinkDevice}
                        type="submit"
                        raised
                        severity={EnhancedButtonPrimeReactSeverity.Success}
                      />
                    </Grid>
                    <Spacer y={1} />

                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                      <Typography variant="body2" color="textSecondary">
                        Not recieved the code ? Choose an option to resend
                      </Typography>
                    </Grid>
                    <EnhancedButtonPrimeReact
                      label="Get Code via SMS"
                      // loading={isPending}
                      type="submit"
                      raised
                      severity={EnhancedButtonPrimeReactSeverity.Secondary}
                      onClickHandler={() => handleCodeRequest("sms")}
                    />
                    <EnhancedButtonPrimeReact
                      label="Get Code via Call"
                      type="submit"
                      raised
                      severity={EnhancedButtonPrimeReactSeverity.Secondary}
                      onClickHandler={() => handleCodeRequest("call")}
                    />
                  </Grid>
                </form>
              </FormProvider>
            }
          />

          {/* Add update phone Number */}

          <EnhancedDialog
            dialogTitle="Phone Setting"
            key="dialog-box"
            testId="dialog"
            open={openAddPhoneModal}
            onCloseHandler={() => setOpenAddPhoneModal(false)}
            dialogContent={
              <FormProvider {...formMethods6}>
                <form
                  onSubmit={formMethods6.handleSubmit(
                    onSubmitToAddPhone,
                    (errors) => { }
                  )}
                >
                  <Grid container spacing={2}>
                    <Grid
                      size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      <EnhancedDropDownRHFWithLabel
                        label="Country Code"
                        testId="country-code-field"
                        selectName="countryCode"
                        items={COUNTRY_CODES}
                        onSelectionChangeHandler={
                          onCountryCodeSelectionChangeHandler
                        }
                        selectedItem={CountryCodeValue}
                      />
                      <span
                        style={{
                          marginTop: "0.7rem",
                          marginLeft: "1rem",
                          color: "rgba(0, 0, 0, 0.6)",
                        }}
                      >
                        {CountryCodeValue}
                      </span>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                      <RHookFormTextFieldWithLabel
                        label="Phone Number"
                        fieldValue="phone"
                        id="phone"
                        testId="phone-field"
                        placeholder={PhoneNumberPlaceholder}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 12 }}>
                      <RHookFormTextFieldWithLabel
                        label="Extension"
                        id="extension"
                        testId="extension"
                      />
                    </Grid>

                    {showOtpField && (
                      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <RHookFormTextFieldWithLabel
                          label="Enter OTP"
                          fieldValue="otp"
                          id="otp"
                          testId="otp-field"
                          placeholder="Enter OTP"
                        />
                      </Grid>
                    )}
                  </Grid>
                </form>
              </FormProvider>
            }
            showdividers={false}
            dialogAction={
              <Grid>
                <EnhancedButtonPrimeReact
                  label={showOtpField ? "Verify OTP" : "Send OTP"}
                  loading={
                    sendOtpMutation.isPending || verifyOtpMutation.isPending
                  }
                  type="submit"
                  raised
                  onClickHandler={formMethods6.handleSubmit(onSubmitToAddPhone)}
                  severity={EnhancedButtonPrimeReactSeverity.Success}
                  data-testid="submit-button" // if EnhancedButtonPrimeReact supports native DOM props
                />
              </Grid>
            }
          />
        </Grid>
        <EnhancedSnackbar
          message={snackbarData.message}
          onCloseHandler={onSnackbarClosed}
          severity={snackbarData.severity}
          testId={"user-account-snackbar"}
          open={snackbarData.open}
        />
      </Grid>
    </>
  );
};
